import useSWRImmutable from 'swr/immutable'

import { getCategories } from '../../api/categories'

const useCategories = (mainCategoryId?: string | null | undefined) => {
  return useSWRImmutable(['categories', mainCategoryId], () => getCategories('', mainCategoryId))
}

export default useCategories
